import jump from 'jump.js'

export default function (event, target) {
  if (!event.currentTarget) {
    return
  }

  const buttonClone = event.currentTarget.cloneNode(true)

  const buttonPosition = {
    top: event.currentTarget.offsetTop,
    left: event.currentTarget.offsetLeft
  }

  const moveVector = {
    x: target.parentNode.offsetLeft + (target.offsetWidth / 2) - buttonPosition.left,
    y: target.parentNode.offsetTop + (target.offsetHeight / 2) - buttonPosition.top
  }

  buttonClone.style.position = 'absolute'
  buttonClone.style.zIndex = '1000'
  buttonClone.style.top = `${buttonPosition.top}px`
  buttonClone.style.left = `${buttonPosition.left}px`
  buttonClone.style.fontSize = '0.9375em'
  buttonClone.style.transition = 'transform 0.8s, opacity 0.4s 0.4s'

  document.body.appendChild(buttonClone)

  // Reflow element for transition
  // eslint-disable-next-line no-unused-expressions
  buttonClone.offsetTop

  buttonClone.style.transform = `translate(${moveVector.x}px, ${moveVector.y}px)`
  buttonClone.style.opacity = '0'

  buttonClone.addEventListener('transitionend', function () {
    if (buttonClone.parentNode) {
      document.body.removeChild(buttonClone)
    }
  })

  const sidebar = document.getElementById('ticket-container-sidebar')

  if (sidebar && window.getComputedStyle(sidebar).getPropertyValue('position') !== 'sticky') {
    jump('#ticket-container-sidebar', { duration: 500 })
  }
}
